module.exports = __webpack_public_path__ + "static/media/convertation.4f2fc346.svg";